import React, {useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSubscriptionSetupApi, updateSubscriptionSetupApi } from 'api/subscription';
import {
  Button,
  Divider,
  Grid,
  Typography,
  Card,
} from '@material-ui/core';
import { BackdropCircular } from 'components';
import { generateRandomString } from 'utils';
import SetupInformation from './SetupInformation';
import SetupPrices from './SetupPrices';
import SetupDiscounts from './SetupDiscounts';


const StoreSetupPrices = () => {
  const dispatch = useDispatch();
  const { isLoading, subscriptionSetup } = useSelector((state) => state.subscription);
  const [setupData, setSetupData] = useState(subscriptionSetup);
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);

  useEffect(() => {
    getSubscriptionSetupApi({ dispatch });
  }, []);

  useEffect(() => {
    setSetupData(subscriptionSetup);
  }, [subscriptionSetup]);

  useEffect(() => {
    if (Object.keys(setupData).length > 0) {
      setIsSaveEnabled(isAllFieldFilled());
    }
  }, [setupData]);

  const handleClickSave = () => {
    updateSubscriptionSetupApi({ dispatch, setupData });
  };

  const editTitle = (dataType, newValue) => {
    setSetupData((setupData) => ({...setupData, [dataType]: { ...setupData[dataType], title: newValue}}));
  };

  // dataType is 'discount' || 'information' || 'price'
  const editOption = (e, dataType, optionId) => {
    const { name: fieldName, value: newValue, checked } = e.target;

    setSetupData((setupData) => {
      const {options} = setupData[dataType];
      const updatedOptions = options.map((c, id) => id === optionId ? ({...c, [fieldName]: fieldName === 'isOneTime' ? checked : newValue}) : c);
      return {...setupData, [dataType]: { ...setupData[dataType], options: updatedOptions }};
    });
  };

  const addOption = (dataType, optionId) => {
    setSetupData((setupData) => {
      const {options} = setupData[dataType];
      let updatedOptions = options.reduce((acc, item, idx) => {
        acc.push(item);

        if (idx === optionId) {
          acc.push(
            dataType === 'information' ? {id: generateRandomString(), label: ''} : {id: generateRandomString(), label: '', price: ''}
          );
        }

        return acc;
      }, []);

      if (!updatedOptions.length) {
        updatedOptions = dataType === 'information' ? [{id: generateRandomString(), label: ''}] : [{id: generateRandomString(), label: '', price: ''}];
      }

      return {...setupData, [dataType]: { ...setupData[dataType], options: updatedOptions }};
    });
  };

  const removeOption = (dataType, optionId) => {
    setSetupData((setupData) => {
      const {options} = setupData[dataType];
      const updatedOptions = options.filter((c, id) => id !== optionId);
      return {...setupData, [dataType]: { ...setupData[dataType], options: updatedOptions }};
    });
  };

  const isAllFieldFilled = () => {
    const isInformatonEmpty =  setupData.information?.options?.find((el) => el.label.length === 0);
    const isPriceEmpty = setupData.price?.options?.find((el) => el.label.length === 0 || (el.price).toString().length === 0);
    const isDiscountEmpty = setupData.discount?.options?.find((el) => el.label.length === 0 || (el.price).toString().length === 0);

    return Boolean(isInformatonEmpty || isPriceEmpty || isDiscountEmpty);
  };

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <Typography variant="h3" className="mb-8">Store Setup Prices</Typography>
      <Card
        className="p-4 mb-4"
        elevation={25}
      >
        {setupData.information &&
        <SetupInformation
          setupData={setupData}
          editTitle={editTitle}
          editOption={editOption}
          addOption={addOption}
          removeOption={removeOption}
        />}
        {setupData.price &&
        <SetupPrices
          setupData={setupData}
          editTitle={editTitle}
          editOption={editOption}
          addOption={addOption}
          removeOption={removeOption}
        />}
        {setupData.discount &&
        <SetupDiscounts
          setupData={setupData}
          editTitle={editTitle}
          editOption={editOption}
          addOption={addOption}
          removeOption={removeOption}
        />}

        <Grid item xs={12}>
          <Divider className="my-5" />
        </Grid>
        <Grid container className="p-4 flex justify-end">
          <Button variant="contained" color="primary" disabled={isSaveEnabled} className="uppercase" onClick={handleClickSave}>Save</Button>
        </Grid>
      </Card>
      <BackdropCircular loading={isLoading} />
    </div>
  );
};

export default StoreSetupPrices;
